module.exports = __webpack_public_path__ + "870214e58ffc22610cd1e7e15edba068.svg";